export default __webpack_public_path__ + "static/media/domain_dns.7dd73052.svg";